<template>
    <div class="ArticleCountMapChart">
        <p v-if="title" class="homeComTitle flex_box" :class="[ imgClass ]">
            <span class="flex_1">{{ title }}</span>
            <span v-if="hintMsg" class="fs12 co_B0 font_n">{{ hintMsg }}</span>
        </p>

        <div>
            <p class="content fs14" v-html="content"></p>
        </div>
        <div class="chartBox" :id='chartId'></div>
    </div>
</template>

<script>
import _ from 'lodash'
import common from '@/util/common'
import 'echarts/map/js/china';

const echarts = require('echarts');

export default {
    name: "ArticleCountMapChart",
    props: {
        title: {
            type: String,
            default: ""
        },
        imgClass: {
            type: String,
            default: 'chartIcon'
        },
        chartId: {
            type: String,
            default: "ArticleCountMapChart"
        },
        hintMsg: {
            type: String,
            default: ""
        },
        entityType: {
            type: String,
            default: 'company',
        },
        renderData: Object,

    },
    data() {
        return {
            content: '今日，暂无舆情报道。',
            maps: [],
            chart: null,
            list: [],
            topArticle: '',
        }
    },
    watch: {
        "industry": function (pre, cur) {
            if (pre && cur)
                this.renderFunc()
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },

    mounted() {
        this.$nextTick(() => {
            this.renderFunc()
        })
    },
    methods: {
        renderFunc() {


            this.list = this.renderData.count;
            this.topArticle = this.renderData.topArticle;
            let mapItems = [];
            if (this.list && this.list.length) {
                mapItems = _.filter(this.list, info => {
                  return info.count;
                });
            }
            mapItems = _.orderBy(mapItems, ['value'], ['desc']);
            this.maps = _.map(mapItems.slice(0, 5), "name");
            if(this.maps.length){
                this.content =`今日，全国舆情报道量较多的${mapItems.length >=5? "前五个" :""}地区为<b>${ this.maps.join("、") }</b>，其中<b>${this.maps[0]}</b>舆情报道量最多`;

                if(this.topArticle && this.topArticle.tendency !== "中性" ){
                    this.content += `，报道量最多的事件是${this.topArticle.tendency =="负面" ? "敏感" : "正面"}事件${common.covertHtmlLink(this.topArticle)}`;
                    if(this.entityType == "industry"){
                        let entitLength = this.topArticle.entities.length;
                        this.content+= entitLength >1 ? `，该事件报道的主体为${this.topArticle.entities[0].name}、${this.topArticle.entities[1].name}${entitLength>2 ? '等。' :'。'}` : entitLength  ==1 ? `，该事件报道的主体为${this.topArticle.entities[0].name}。`: `。`
                    }else {
                        this.content += `。`
                    }
                   }else {
                    this.content += `。`
                }
            }


            let max = _.maxBy(this.list, "count") ? _.maxBy(this.list, "count").count : 20;
            max = this.getMax(max);
            let min = 0; //_.minBy(this.list, "count") ? _.minBy(this.list, "count").count : 0;
            let splitNumber = 5;
            let remainder = (max - min) % 5;
            if (remainder) {
                max = max + (5 - remainder);
            }
            if(max < 30 && this.list.length < 5){//兼容没有区域的文章
                max = 100;
                splitNumber = 1;
                min = 1;
            }

            let myCharts = document.getElementById(this.chartId)  // 增加这一行
            myCharts.style.width = (window.innerWidth - 32) + 'px';
            this.chart = echarts.init(myCharts);

            let mapName = 'china',
                geoCoordMap = {};

            /*获取地图数据*/
            this.chart.showLoading();
            let mapFeatures = echarts.getMap(mapName).geoJson.features;
            this.chart.hideLoading();

            mapFeatures.forEach(function (v) {
                let name = v.properties.name; // 地区名称
                geoCoordMap[name] = v.properties.cp; // 地区经纬度
            });

            let convertData = function (data) {
                let res = [];
                data.forEach(item => {
                    let geoCoord = geoCoordMap[item.name];
                    if (geoCoord) {
                        // console.log(util.formatPercentAndCeil(item.count, total) ,item.count, total);
                        res.push({
                            name: item.name,
                            // value: geoCoord.concat(item.count > 0 ? item.count : -1),
                            value: item.count,
                        });
                    }
                })
              // console.log(res)
                return res;
            };

            let splitList = [
                {gte: 1, lt: 10, label: ""},
                {gte: 10, lt: 20, label: ""},
                {gte: 20, lt: 30, label: ""},
                {gte: 30, lt: 40, label: ""},
                {gte: 40, lt: ""},
            ];
            let splitNum = this.getMax(max / 5);
            _.forEach(splitList, (s, index) => {
                s.gte = !index ? 1 : splitNum * (index - 1) + splitNum;
                if (s.lt)
                    s.lt = splitNum * (index + 1);
                s.label = s.lt ? `${s.gte} ~ ${s.lt}` : `≥ ${s.gte}`
                if(index === splitList.length - 1) // 不设置最后一个lt，地图显示会有问题
                    s.lt = splitNum * (index + 1);
            })
            max = splitNum * 5
            // console.log(max, min, splitList, )
            let option = {
                tooltip: {
                    trigger: 'item',
                    show: false
                },
                visualMap: {
                    show: true,
                    text: ["报道量"],
                    min: min,
                    max: max,
                    padding:20,
                    // left: 26,
                    bottom: -20,
                    splitNumber: splitNumber,
                    precision: 0,
                    itemGap: 2,
                    itemHeight: 10,
                    showLabel: !0,
                    seriesIndex: [0],
                    inRange: {
                        color: ['#eaedfa', '#caddfd', '#9cc2fc', '#7da2fa', '#0962fa'] // 渐变颜色
                    },
                    splitList: splitList
                },
                geo: {
                    zoom: 1.2,
                    map: mapName,
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                        }
                    },
                    roam: false,
                    right: '2%',
                    layoutCenter: ["55%", "45%"], //地图位置
                    layoutSize: '90%',
                    emphasis: {
                        itemStyle: {
                            areaColor: '#d3e0f5', // 地图
                            disabled: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#fff',
                            borderColor: '#c9c9ca',
                        },
                        select: {
                            disabled: true
                        },
                    }
                },
                series: [
                    {
                        type: 'map',
                        map: mapName,
                        // layoutCenter: ["80%", "30%"], //地图位置
                        zoom: 1,
                        geoIndex: 0,
                        aspectScale: 0.65, //长宽比
                        showLegendSymbol: true, // 存在legend时显示
                        data: convertData(mapItems)
                    }
                ]
            };
            this.chart.setOption(option);
        },
        getMax(n) {
          let max = n;
          let d = Math.ceil(Math.log10(n));
          if(d <= 3)
            max = Math.ceil(n / Math.pow(10, d - 1)) * Math.pow(10, d - 1);
          else {
            max = Math.ceil(n / Math.pow(10, d - 2)) * Math.pow(10, d - 2);

          }
          // console.log('getMax', n, max)
          return max
        }
    }
}
</script>

<style lang="scss" scoped>
.ArticleCountMapChart {
    padding: 20px 16px;
    background-color: #FFFFFF;

    .content {
        line-height: 20px;
        margin: 12px 0px 10px;
    }
    .chartBox{
        //height: 250px;
    }
}
</style>